<template>
    <b-form-group :label="label" :description="description" :invalid-feedback="error" :state="state">
        <template v-if="label && !floatingLabel" v-slot:label>
            <div class="d-flex">
                <span>{{ label }}</span>
                <fa-icon-tooltip
                    v-if="$slots.tooltip"
                    :id="'icon-info' + Math.random()"
                    :icon="['fas', 'circle-info']"
                    class="text-primary"
                    variant="secondary"
                >
                    <slot name="tooltip"></slot>
                </fa-icon-tooltip>
            </div>
        </template>
        <form-input-group :left-icon="leftIcon">
            <b-input-group-prepend is-text v-if="leftButton">
                <slot name="leftButton"></slot>
            </b-input-group-prepend>
            <b-form-select
                v-on="listeners"
                v-bind="attrs"
                :class="[
                    'ldx-form-select',
                    'rounded-right',
                    fullWidth ? '' : 'auto-width',
                    floatingLabel ? 'floating-label' : '',
                    isGrayFirst ? '' : 'gray-first',
                ]"
                :value="value"
                :state="state"
                :options="options"
                :disabled="disabled"
                @input="onInput"
            ></b-form-select>
            <label :if="floatingLabel" :style="{ left: leftIcon || leftButton ? '3.3rem' : '' }"
                >{{ floatingLabel }}
                <span v-if="floatingLabelAsterisk"
                    ><font-awesome-icon
                        color="#0D47A1"
                        :icon="['fas', 'circle-info']"
                        :style="{ 'vertical-align': 'top', position: 'relative', top: '1px' }" /></span
                ><span v-if="floatingLabelDoubleAsterisk"
                    ><font-awesome-icon
                        color="#0D47A1"
                        :icon="['fas', 'circle-info']"
                        :style="{ 'vertical-align': 'top', position: 'relative', top: '1px' }" /></span
            ></label>
        </form-input-group>
    </b-form-group>
</template>

<script>
    import { formFieldMixin } from '../../../mixins/form-field-mixin';
    import FormInputGroup from '../form-input-group/form-input-group.vue';
    import FaIconTooltip from '../fa-icon-tooltip/fa-icon-tooltip.vue';

    export default {
        name: 'FormSelect',
        mixins: [formFieldMixin],
        components: {
            FaIconTooltip,
            FormInputGroup,
        },
        data() {
            return {
                isGrayFirst: false,
            };
        },
        created() {
            if (this.grayFirst) {
                this.onInput(1);
            }
        },
        props: {
            value: {},
            leftIcon: [Object, Array, String],
            leftButton: Boolean,
            fullWidth: {
                type: Boolean,
                default: true,
            },
            options: {
                type: [Array, Object],
                default: () => [],
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            grayFirst: {
                type: Boolean,
                default: false,
            },
            floatingLabel: [String, Number],
            floatingLabelAsterisk: {
                type: Boolean,
                default: false,
            },
            floatingLabelDoubleAsterisk: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            onInput(value) {
                if (this.grayFirst) {
                    if (value == 1 && this.options.length > 0 && this.options[0].value === null) {
                        this.isGrayFirst = true;
                    } else {
                        this.isGrayFirst = false;
                    }
                }
                this.input(value);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../variables.scss';

    .auto-width {
        width: auto !important;
    }

    .gray-text {
        color: gray;
    }

    select.floating-label {
        line-height: 1.6;
        padding-bottom: 0.1rem;
        padding-top: 1rem;
        z-index: inherit;
        height: $floating-label-input-height-active;

        & + label {
            position: absolute;
            user-select: none;
            pointer-events: none;
            margin: 0;
            top: 0.2rem;
            left: 0.8rem;
            z-index: 99;
            font-size: 0.8rem;
            line-height: 1.1;
            color: $floating-label-color-active;
            font-weight: $floating-label-font-weight;
        }
    }
</style>
